import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const OnboardingContainer = styled.div`
  display: flex;

  width: 100%;
  height: 100dvh;

  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const RightPanelWrapper = styled.div`
  width: 50%;
  display: none;

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 50%;
  }
`;

export const LeftPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  min-height: 0;
  width: 100%;
  max-width: ${({ theme }) => `calc(34.4rem + ${theme.spacing(8)})`};
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(4)} 0`};
  margin: 0 auto;
`;

export const RightPanel = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};
  overflow: hidden;
`;

export const RightPanelImage = styled.img`
  position: absolute;

  top: 50%;
  left: 20%;
  max-width: 598px;

  transform: translateY(-50%);
`;

export const Form = styled.form`
  overflow-y: auto;
  padding: ${({ theme }) => `${theme.spacing(1.5)}`};

  padding: ${({ theme }) => `${theme.spacing(6)}`};
  margin: ${({ theme }) => `-${theme.spacing(6)}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Subtitle = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  padding: ${({ theme }) => `${theme.spacing(1)} 0 ${theme.spacing(4)}`};
  margin: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const FooterArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `0 0 ${theme.spacing(2)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(3)};

  background: ${({ theme, $active }) =>
    $active
      ? rgba(theme.palette.primaryExtended.opacityBackgroundBackground, 0.1)
      : theme.palette.background.default};
  border: 1px solid
    ${({ theme, $active }) =>
      $active
        ? rgba(theme.palette.primaryExtended.opacityBackgroundBackground, 0.2)
        : theme.palette.divider};
  border-radius: 8px;
  cursor: pointer;
  transition:
    border-color 200ms,
    background 200ms;
`;

export const ListItemContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const ListItemIcon = styled.span<{ $color: string | null | undefined }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  min-height: 2rem;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.grey[100]};

  color: ${({ theme }) => theme.palette.grey[800]};
  font-size: 1.2rem;
  line-height: 62.5%;

  ${({ $color }) =>
    $color &&
    css`
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;

        width: 0.6rem;
        height: 0.6rem;

        background: ${$color};
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.palette.common.white};
        transform: translate(33%, 33%);
      }
    `}
`;

export const CheckboxContainer = styled.div`
  pointer-events: none;
  line-height: 62.5%;
`;
